import { useState, useCallback, useMemo, useEffect, useRef } from "react";
import { ChevronDown } from "lucide-react";

import {
  Box,
  TextField,
  IconButton,
  List,
  ListItem,
  Paper,
  Skeleton,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import debounce from "lodash.debounce";
import {
  Toolbar,
  Typography,
  Modal,
  Menu,
  Button,
  Drawer,
} from "@mui/material";

import { Puzzle, X } from "lucide-react";
import { MapPinHouse } from "lucide-react";
import { UserRoundPen } from "lucide-react";
import { Wallet } from "lucide-react";
import { HandCoins } from "lucide-react";
import { BadgeHelp } from "lucide-react";

import Login from "../pages/login/Login";
import { Link, useLocation } from "react-router-dom";

import {
  Heart,
  ShoppingCart,
  Settings,
  ShieldCheck,
  SendToBack,
} from "lucide-react";
import { useNavigate } from "react-router-dom";
import { AlignJustify } from "lucide-react";

import MenuItem from "@mui/material/MenuItem";
// import Avatar from "@mui/material/Avatar";
import NoImage from "../Assests/blank_delete.png";

import logo from "../Assests/logo.png";
import small_logo from "../Assests/small-logo.png";
// import IMg from "../Assests/photo.jpg";

import { useSelector } from "react-redux";
import { handleAuthModal, logoutUser } from "../Redux/Auth";
import { useDispatch } from "react-redux";
import Image from "./Image";
import SignupFlow from "../pages/signup/SignupFlow";
import { apiPublic } from "../api/api";
import { Produts_Add, signup_url, Wish } from "../api/urls";
import Forgot from "../pages/Forgot/Forgot";
import useFetch from "../hooks/useFetch";
import { ProtectedNavigate } from "./ProtectRoutes";
// import ProfileImage from "../pages/profile/ProfileImage";
// import ProtectRoutes from "./ProtectRoutes";
import { setDefaultCreditData } from "../Redux/B2b";
import { setDefaultWalletData } from "../Redux/Wallet";
import { setDefaultPointData } from "../Redux/Point";
import { setDefaultWishlistData } from "../Redux/WishlistSlice";
import { setDefaultCartData } from "../Redux/CartSlice";
import { motion } from "framer-motion";
import CategorySelection from "./CategorySelection";
import RightDrawer from "./Right_Drawer/Right_Drawer";

export const SearchComp = ({ onSearchResults, onClose }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(-1);

  const navigate = useNavigate();
  const searchRef = useRef(null);
  const [isLoading, setIsLoading] = useState(false);

  const debouncedFetch = useMemo(
    () =>
      debounce(async (query) => {
        if (!query.trim()) {
          setSearchResults([]);
          setShowDropdown(false);
          return;
        }
        setIsLoading(true);

        try {
          setShowDropdown(true);
          const response = await apiPublic.get(Produts_Add, {
            params: { search: query },
          });

          const results = response?.data?.results || []; // <-- CHANGE HERE
          setSearchResults(results);

          setShowDropdown(results.length > 0);

          if (typeof onSearchResults === "function") {
            onSearchResults(results);
          }
        } catch (error) {
          console.error("Error fetching search results:", error);
          setSearchResults([]); // Ensure empty array on error
        } finally {
          setIsLoading(false);
        }
      }, 500),
    [onSearchResults],
  );

  const fetchSearchResults = useCallback(
    (query) => debouncedFetch(query),
    [debouncedFetch],
  );

  const handleSearchChange = (event) => {
    const query = event.target.value;
    setSearchTerm(query);
    fetchSearchResults(query);
    setSelectedIndex(-1); // Reset selection index
  };

  const handleResultClick = (product) => {
    navigate(`/products/${product.id}`);
    setSearchResults([]);
    if (onClose) {
      onClose();
    }
    setShowDropdown(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (searchRef.current && !searchRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleKeyDown = (event) => {
    if (event.key === "ArrowDown") {
      setSelectedIndex((prev) =>
        prev < searchResults.length - 1 ? prev + 1 : prev,
      );
    } else if (event.key === "ArrowUp") {
      setSelectedIndex((prev) => (prev > 0 ? prev - 1 : prev));
    } else if (event.key === "Enter" && selectedIndex >= 0) {
      handleResultClick(searchResults[selectedIndex]);
    }
  };

  return (
    <Box
      ref={searchRef}
      sx={{
        flexGrow: 1,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        position: "relative",
      }}
    >
      {/* Search Input */}
      <TextField
        variant="outlined"
        placeholder="Search Product..."
        size="small"
        value={searchTerm}
        onChange={handleSearchChange}
        onKeyDown={handleKeyDown}
        autoComplete="off" // Disables autocomplete
        inputProps={{
          autoComplete: "off", // Ensures autocomplete is disabled
          spellCheck: "false", // Disables spell check
        }}
        sx={{
          width: "100%",
          maxWidth: "500px",
          // background: "#F3F3F3",
          // background: "red",
          borderRadius: "8px",
          "& .MuiOutlinedInput-root": { paddingRight: "8px" },
        }}
        InputProps={{
          endAdornment: (
            <IconButton disableRipple>
              <SearchIcon />
            </IconButton>
          ),
        }}
      />

      {/* Search Results Dropdown */}

      <Paper
        hidden={!showDropdown}
        className="absolute top-10 truncate"
        sx={{
          // position: "absolute",
          // top: "100%",
          // left: "50%", // Centering it
          // transform: "translateX(-50%)", // Aligning center
          zIndex: 3,
          maxHeight: "300px",
          overflowY: "auto",
          width: "80%", // Adjust width (reduce this to your preference)
          maxWidth: "500px", // Set a max width to prevent too wide dropdown
          // minWidth: "280px",
        }}
      >
        {isLoading ? (
          <List>
            {[...Array(5)].map((_, idx) => (
              <ListItem key={idx}>
                <Skeleton variant="text" width={300} height={30} />
              </ListItem>
            ))}
          </List>
        ) : (
          <List>
            {searchResults.map((product, index) => (
              <ListItem
                key={product.id}
                button
                onClick={() => handleResultClick(product)}
                selected={selectedIndex === index}
                sx={{
                  cursor: "pointer",
                  backgroundColor:
                    selectedIndex === index ? "#f0f0f0" : "transparent",
                  "&:hover": { backgroundColor: "#f5f5f5" },
                }}
              >
                {product.title}
              </ListItem>
            ))}
          </List>
        )}
      </Paper>
    </Box>
  );
};

const Navbar = () => {
  const productcart = useSelector((state) => state.cart);
  const wishlist = useSelector((state) => state.wishlist);
  const cart = useSelector((state) => state.cart);

  const { accessToken, user } = useSelector((state) => state.auth);
  const { data: userData } = useFetch(accessToken && signup_url);
  const isModalOpen = useSelector((state) => state.auth.isAuthModalOpen);
  const [anchorEl, setAnchorEl] = useState(null);
  // const [openSearch, setOpenSearch] = useState(false);
  const [open, setOpen] = useState(false);
  const [unRegistered, setIsUnRegistered] = useState(0);
  // const [openCategoryDrawer, setOpenCategoryDrawer] = useState(false);
  const [showDrawer, setShowDrawer] = useState(false);
  // const [showB2BPopup, setShowB2BPopup] = useState(false);

  const location = useLocation();
  const navigate = useNavigate();
  // console.log(location?.search, "i am search")
  useEffect(() => {
    if (location?.search.includes("view-order")) {
      navigate("/your_order");
    } else if (location?.search.includes("b2b-ledger")) {
      navigate("/b2b_credit");
    } else if (location?.search.includes("wallet-ledger")) {
      navigate("/wallet");
    }
  }, [location?.search, navigate]);
  const toggleDrawer = (newOpen) => () => {
    setOpen(newOpen);
  };

  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const closeAuth = () => {
    dispatch(handleAuthModal(false));
    setIsUnRegistered(0);
  };
  const dispatch = useDispatch();

  // useEffect(() => {
  //   if (!user) {

  //     dispatch(handleAuthModal(true));
  //   }
  // }, [user, location.pathname, dispatch]);

  useEffect(() => {
    const protectedRoutes = [
      "/your-orders",
      "/wishlist",
      "/profile",
      "/address",
    ];

    // Check if user is not logged in AND current path is protected
    if (!user && protectedRoutes.includes(location.pathname)) {
      dispatch(handleAuthModal(true));
    }
  }, [user, location.pathname, dispatch]);
  const handleRemoveData = () => {
    dispatch(setDefaultCreditData());
    dispatch(setDefaultWalletData());
    dispatch(setDefaultPointData());
    dispatch(setDefaultWishlistData());
    dispatch(setDefaultCartData());
  };
  const handleLogout = () => {
    dispatch(logoutUser());
    handleRemoveData();
    navigate("/");
  };

  useEffect(() => {
    if (!accessToken) {
      handleRemoveData();
    }
  }, [accessToken]);

  const handleClick = () => {
    navigate("/shop_cart");
  };

  const handleWishlistClick = () => {
    navigate("/wishlist");
  };
  const menuItems = [
    { icon: <SendToBack />, text: "My Order", path: "/your_order" },
    { icon: <Settings />, text: "B2B Portal", path: "/setting" },

    // {
    //   icon: <ShoppingBasket />,
    //   text: "Products",
    //   path: "/products",
    // },
    { icon: <MapPinHouse />, text: "Address", path: "/my_address" },
    { icon: <Puzzle />, text: "Coupon", path: "/discount_coupon" },
    { icon: <UserRoundPen />, text: "Profile", path: "/profile" },
    { icon: <Wallet />, text: "Pentagon Wallet", path: "/wallet" },
    { icon: <HandCoins />, text: "Pentagon Points", path: "/points" },
    { icon: <BadgeHelp />, text: "Help Center", path: "/help_center" },
    // {
    //   icon: <KeyRound />,
    //   text: "Change Password",
    //   path: "/change_password",
    // },
    // { icon: <House />, text: "Seller", path: "/seller" },
    // { icon: <Gem />, text: "Brand", path: "/brand" },
  ];
  const handleSignin = () => {
    dispatch(handleAuthModal(true));
    setIsUnRegistered(0);
  };

  return (
    <>
      <section className="desktop sticky top-0 left-0 flex-col z-[1000] bg-white">
        <Toolbar
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <div className="flex items-center">
            <Typography variant="h6">
              <Link to="/" style={{ textDecoration: "none" }}>
                <Image src={logo} alt="Logo" className={"w-[200px]"} />
              </Link>
            </Typography>
          </div>

          <SearchComp />

          <Box sx={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <ProtectedNavigate path={"/wishlist"}>
              <IconButton
                aria-label="wishlist"
                disableRipple
                // onClick={handleWishlistClick}
                sx={{ position: "relative", color: "black" }}
              >
                <Heart size={25} />
                {user && wishlist?.length > 0 && (
                  <span className="bg-red-600 text-white rounded-full text-xs font-medium h-6 w-6 flex items-center justify-center absolute -top-1 -right-2">
                    {wishlist?.length > 9 ? "9+" : wishlist?.length}
                  </span>
                )}
              </IconButton>
            </ProtectedNavigate>
            <ProtectedNavigate path={"/shop_cart"}>
              <IconButton
                aria-label="shopping cart"
                disableRipple
                sx={{ position: "relative", color: "black" }}
              >
                <ShoppingCart size={25} />
                {user && cart?.items?.length > 0 && (
                  <span className="bg-red-600 text-white rounded-full text-xs font-medium h-6 w-6 flex items-center justify-center absolute -top-1 -right-2">
                    {cart?.length > 9 ? "9+" : cart?.items?.length}
                  </span>
                )}
                {productcart?.length > 0 && (
                  <span
                    style={{
                      backgroundColor: "red",
                      color: "white",
                      borderRadius: "50%",
                      fontSize: "12px",
                      fontWeight: "bold",
                      width: "18px",
                      height: "18px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      position: "absolute",
                      top: "-5px",
                      right: "-5px",
                    }}
                  >
                    {productcart?.length}
                  </span>
                )}
              </IconButton>
            </ProtectedNavigate>

            {!user ? (
              <button
                // style={{
                //   width: "90px",
                //   height: "40px",
                //   borderRadius: "30px",
                //   background: "#000000",
                //   color: "#fff",
                //   border: "none",
                //   cursor: "pointer",
                //   fontWeight: "500",
                // }}
                className="rounded-full py-2 px-4 bg-black text-white text-sm"
                onClick={handleSignin}
              >
                Sign In
              </button>
            ) : (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                }}
              >
                <Box
                  component="img"
                  src={
                    user?.profile_image || userData?.profile_image || NoImage
                  }
                  alt="Profile"
                  sx={{
                    width: { xs: 20, sm: 30, md: 40, lg: 40 },
                    height: { xs: 20, sm: 30, md: 40, lg: 40 },
                    borderRadius: "50%",
                    objectFit: "cover",
                  }}
                />
                <Button aria-label="more options" onClick={handleMenuClick}>
                  <Typography
                    sx={{
                      color: "black",
                      fontSize: "16px",
                      fontWeight: "500",
                      textTransform: "capitalize",
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                    }}
                  >
                    {user?.full_name || userData?.full_name} <ChevronDown />
                  </Typography>
                </Button>
              </div>
            )}
          </Box>
        </Toolbar>

        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleClose}
          sx={{ zIndex: 9999 }}
        >
          {menuItems.map((item, index) => (
            <MenuItem
              key={index}
              // onClick={() => {
              //   handleClose();
              //   setTimeout(() => navigate(item.path), 100); // smooth transition
              // }}
              onClick={() => {
                handleClose();

                if (item.text === "B2B Portal") {
                  if (userData?.bnpl_approved) {
                    setTimeout(() => navigate(item.path), 100);
                  }
                } else {
                  setTimeout(() => navigate(item.path), 100);
                }
              }}
            >
              {item.icon}
              <span style={{ marginLeft: "8px" }}>{item.text}</span>
            </MenuItem>
          ))}

          <MenuItem
            onClick={() => {
              handleClose();
              handleLogout();
            }}
          >
            <ShieldCheck />
            <div style={{ marginLeft: "8px", cursor: "pointer" }}>Logout</div>
          </MenuItem>
        </Menu>
        {/* <Popover showDrawer={showDrawer} setShowDrawer={setShowDrawer} /> */}
        <RightDrawer open={showDrawer} onClose={() => setShowDrawer(false)} />

        <CategorySelection handleSignin={handleSignin} />
      </section>

      <div
        className="mobile"
        style={{
          backgroundColor: "white",
          top: 0,
          left: 0,
          zIndex: 1100,
          boxShadow: "0px 2px 6px rgba(0, 0, 0, 0.1)",
          padding: "10px 8px",
          color: "black",
          flexDirection: "row",
          alignItems: "center",
          position: "sticky",
          justifyContent: "space-between",
        }}
      >
        <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
          {user && (
            <AlignJustify onClick={toggleDrawer(true)} className="shrink-0" />
          )}
          <img
            src={small_logo}
            alt="Logo"
            style={{
              width: "30px",
              height: "fit-content",
              borderRadius: "5px",
            }}
            onClick={() => navigate("/")}
          />
        </div>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "end",
            gap: "5px",
          }}
        >
          {!user ? (
            <div
              style={{
                color: "black",
                border: "none",
                cursor: "pointer",
                fontWeight: "500",
                fontSize: "16px",
              }}
              onClick={() => dispatch(handleAuthModal(true))}
            >
              Sign-In
            </div>
          ) : (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
              }}
            >
              {/* <Avatar alt="User" src={IMg} size={30} /> */}
            </div>
          )}

          <IconButton
            aria-label="wishlist"
            disableRipple
            onClick={handleWishlistClick}
            sx={{ position: "relative", color: "black" }}
          >
            <Heart size={25} />
            {wishlist?.length > 0 && accessToken && (
              <div
                style={{
                  backgroundColor: "red",
                  color: "white",
                  borderRadius: "50%",
                  fontSize: "12px",
                  fontWeight: "bold",
                  width: "18px",
                  height: "18px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  position: "absolute",
                  top: "1px",
                  right: "-2px",
                }}
              >
                {wishlist?.length}
              </div>
            )}
          </IconButton>

          <IconButton
            aria-label="shopping cart"
            disableRipple
            onClick={handleClick}
            sx={{ position: "relative", color: "black" }}
          >
            <ShoppingCart size={25} />
            {productcart?.length > 0 && (
              <span
                style={{
                  backgroundColor: "red",
                  color: "white",
                  borderRadius: "50%",
                  fontSize: "12px",
                  fontWeight: "bold",
                  width: "18px",
                  height: "18px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  position: "absolute",
                  top: "-5px",
                  right: "-5px",
                }}
              >
                {productcart?.length}
              </span>
            )}
          </IconButton>
          <SearchIcon
            onClick={() => {
              // setOpenSearch((prev) => !prev)
              setShowDrawer((prev) => !prev);
            }}
          />
        </Box>

        <Drawer open={open} onClose={toggleDrawer(false)}>
          <div
            style={{
              borderBottom: "1px solid lightgray",
              textAlign: "right",
            }}
          >
            <IconButton onClick={toggleDrawer(false)}>
              <X />
            </IconButton>
          </div>
          {menuItems.map((item, index) => (
            <MenuItem
              key={index}
              sx={{ gap: 2 }}
              // onClick={() => dispatch(handleAuthModal(true))}
              onClick={() => {
                // toggleDrawer(false);
                navigate(item.path);
              }}
            >
              {item.icon}
              <p>{item.text}</p>
            </MenuItem>
          ))}
          <MenuItem
            onClick={() => {
              handleClose();
              handleLogout();
            }}
          >
            <ShieldCheck />
            <div style={{ marginLeft: "8px", cursor: "pointer" }}>Logout</div>
          </MenuItem>
        </Drawer>
      </div>

      {location.pathname !== "/login" && (
        <Modal
          open={isModalOpen}
          onClose={() => dispatch(handleAuthModal(false))}
        >
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              borderRadius: "8px",
              outline: "none",
              border: "none",
            }}
          >
            <div style={{ height: "100vh" }} className="center-content">
              <motion.div
                initial={{ opacity: 0, y: -20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6 }}
                className="auth-card"
              >
                <div className="xIcon" onClick={closeAuth}>
                  <X />
                </div>
                {unRegistered === 0 ? (
                  <Login
                    // onClose={closeAuth}
                    setIsUnRegistered={setIsUnRegistered}
                  />
                ) : unRegistered === 1 ? (
                  <SignupFlow
                    // onClose={closeAuth}
                    setIsUnRegistered={setIsUnRegistered}
                  />
                ) : (
                  <Forgot onClose={closeAuth} />
                )}
              </motion.div>
            </div>
          </Box>
        </Modal>
      )}
    </>
  );
};
export default Navbar;
